import React, { useContext, useEffect, useState } from "react";
import pharmacy from "../../images/pharmacy.png";
import medicine from "../../images/medicine.png";
import paramedics from "../../images/paramedics.png";
import alied from "../../images/alied-health.png";
import ambulance from "../../images/ambulance.png";
import med1 from "../../images/medicine-1.png";
import med2 from "../../images/medicine-2.png";
import med3 from "../../images/medicine-3.png";
import med4 from "../../images/medicine-4.png";
import { FaChevronDown } from "react-icons/fa";
import { BiSlider } from "react-icons/bi";
import { AiOutlineSearch, AiFillStar } from "react-icons/ai";
import { TbBuildingBank } from "react-icons/tb";
import { GiPathDistance } from "react-icons/gi";
import Navbar from "../Shared/Navbar/Navbar";
import Footer from "../Shared/Footer/Footer";
import { Link } from "react-router-dom";
import axios from "axios";
import { context } from "../FrontPanel/FrontPanel";

const PharmacyList = () => {
  const [activeTab, setActiveTab] = useState("Pharmacy");
  const tabs = [
    { id: 1, name: "Pharmacy", img: pharmacy },
    { id: 2, name: "Medicine", img: medicine },
    { id: 3, name: "Paramedics", img: paramedics },
    { id: 4, name: "Ambulance", img: alied },
    { id: 5, name: "Allied Health", img: ambulance },
  ];
  const [pharmacyData, setpharmacyData] = useState([]);
  const [masterPhaymactData, setmasterPhaymactData] = useState([]);
  const { setPharmacyDataDetails } = useContext(context);

  const [allProductsBySeller, setallProductsBySeller] = useState([]);
  const [searchType, setsearchType] = useState("Type");
  const [loding, setloding] = useState(2);

  useEffect(() => {
    setloding(0);
    const controller = new AbortController();
    axios
      .get(`all-products`, {
        signal: controller.signal,
      })
      .then((res) => {
        setallProductsBySeller(res.data.all);
      });

    const geometry = JSON.parse(localStorage.getItem("address")).geometry;

    if (geometry) {
      axios
        .post("near-by-store-full-info", geometry)
        .then((res) => {
          console.log("res", res.data);

          if (res.data.all.length > 0) {
            const resultData = [];
            res.data.all.map(async (item, i) => {
              const directionService =
                new window.google.maps.DirectionsService();
              const results = await directionService.route({
                origin: {
                  lat: Number(geometry.lat),
                  lng: Number(geometry.lng),
                },
                destination: { lat: Number(item.lat), lng: Number(item.lng) },
                travelMode: window.google.maps.TravelMode.DRIVING,
              });
              const data = {
                ...item,
                distance: results.routes[0].legs[0].distance.text,
                duration: results.routes[0].legs[0].duration.text,
              };

              resultData.push(data);
            });
            setTimeout(() => {
              setpharmacyData(resultData);
              setmasterPhaymactData(resultData);
              setloding(2);
            }, 1000);
          } else {
            setloding(1);
          }

          // console.log("con", convertedData);

          // setpharmacyData(res.data.all);
          // setmasterPhaymactData(res.data.all);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    return () => {
      controller.abort();
    };
  }, []);

  console.log("data", pharmacyData);

  const handleSearch = (e) => {
    if (searchType === "Medicen") {
      const data = allProductsBySeller.filter((item) =>
        item.name.toLowerCase().match(e.target.value.toLowerCase())
      );
      var fil = data.map((item) => item?.user?.store);
    } else {
      var fil = pharmacyData.filter((item) =>
        item.store_name.toLowerCase().match(e.target.value.toLowerCase())
      );
    }

    console.log("fill", fil);

    if (e.target.value.length > 0) {
      setpharmacyData(fil);
    } else {
      setpharmacyData(masterPhaymactData);
    }
  };

  return (
    <div className="pharmacy-list-container">
      <Navbar />
      <div className="pharmacy-list-content mx-6 sm:mx-12 md:mx-20 lg:mx-28 mt-10">
        <div className="pharmacy-list-tab-content grid grid-cols-3 sm:grid-cols-5 md:grid-cols-3 lg:grid-cols-5 gap-2">
          {tabs.map((item, i) => (
            <div
              key={i}
              onClick={() => setActiveTab(item.name)}
              className={`pharmacy-list-tab ${activeTab === item.name &&
                "border-b-4 border-[#134E47] font-semibold"
                } flex custom-shadow rounded-md text-[#134E47] p-2`}
            >
              <div className="w-1/2 flex items-end">
                <p>{item.name}</p>
              </div>
              <div className="w-1/2 hidden md:block">
                <img className="w-full h-[60px]" src={item.img} alt="" />
              </div>
            </div>
          ))}
        </div>
        <div className="pharmacy-list-filter grid grid-cols-12 gap-2 mt-4">
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <div className="dropdown dropdown-bottom w-full ">
              <label
                tabIndex={0}
                className="w-full px-2 sm:px-9 py-[10px] text-[#134E47] rounded custom-shadow block m-1"
              >
                <BiSlider className="inline mr-2" />
                <span className="hidden lg:inline">Filter</span>
                <FaChevronDown className="hidden lg:inline-block ml-5 text-[14px]" />
              </label>
              <ul
                tabIndex={0}
                className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52"
              >
                {masterPhaymactData.map((item, i) => {
                  return (
                    <li
                      onClick={() => {
                        const fil = masterPhaymactData.filter((value) =>
                          value.store_name
                            .toLowerCase()
                            .match(item.store_name.toLowerCase())
                        );
                        setpharmacyData(fil);
                      }}
                      key={i}
                    >
                      <a>{item.store_name}</a>
                    </li>
                  );
                })}
                <li onClick={() => setpharmacyData(masterPhaymactData)}>
                  <a>All</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <div className="dropdown dropdown-bottom w-full ">
              <label
                tabIndex={1}
                className="w-full px-2 sm:px-9 py-[10px] text-[#134E47] rounded custom-shadow block m-1"
              >
                <BiSlider className="inline mr-2" />
                <span className="hidden lg:inline">{searchType}</span>
                <FaChevronDown className="hidden lg:inline-block ml-5 text-[14px]" />
              </label>
              <ul
                tabIndex={0}
                className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52"
              >
                <li onClick={() => setsearchType("Pharmacy ")}>
                  <a>Pharmacy </a>
                </li>
                <li onClick={() => setsearchType("Medicine")}>
                  <a>Medicine</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-span-8 md:col-span-6 lg:col-span-8 mt-1 ml-1">
            <label className="relative block">
              <span className="sr-only">Search</span>
              <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                <AiOutlineSearch />
              </span>
              <input
                className="placeholder:italic placeholder:text-slate-400 block bg-white w-full border border-none rounded-md py-3 pl-9 pr-3 custom-shadow focus:outline-none focus:border-none focus:ring-none focus:ring-none text-sm"
                placeholder="Search for Pharmacy, Medicine, Paramedics, Ambulance and Allied Health"
                type="text"
                name="search"
                onChange={(e) => handleSearch(e)}
              />
            </label>
          </div>
        </div>
        <div className="pharmacy-list mt-4">
          <div className="pharmacy">
            <div className="flex mb-3">
              <TbBuildingBank className="inline mt-[2px] mr-3" />
              <h6 className="text-[#134E47] font-bold lg:text-[18px]">
                Your Favorite Pharmacy
              </h6>
            </div>
            <div className="grid md:grid-cols-2 grid-cols-1 lg:grid-cols-4 gap-3">
              {loding === 0 && (
                <h6 className="text-[#ca3530] font-bold lg:text-[16px]">
                  keep patience , data is loading....
                </h6>
              )}
              {loding === 1 && (
                <h6 className="text-[#2db32d] font-bold lg:text-[16px]">
                  No data found
                </h6>
              )}
              {loding === 2 &&
                pharmacyData.map((item, i) => (
                  <Link
                    onClick={() => {
                      {
                        setPharmacyDataDetails(item);
                      }
                    }}
                    to={`/medicine-list/${item.seller_id}`}
                    key={i}
                  >
                    <div className="pharmacy-data rounded-lg custom-shadow relative">
                      <img
                        className="h-18 sm:h-28 md:h-36 w-full "
                        src={`${global.img_Url}/${item.store_image}`}
                        alt=""
                      />
                      <div className="time-card px-3 py-1 text-center rounded-tr-lg rounded-bl-lg bg-white absolute right-0 top-0">
                        <h6 className="text-[#134E47] font-bold ">{item.duration}</h6>
                        {/* <p className="text-[#134E47] text-sm">MIN</p> */}
                      </div>
                      <div className="grid grid-cols-3 p-2">
                        <div className="title col-span-2">
                          <h6 className="text-[#134E47] font-bold">
                            {item.store_name}
                          </h6>
                          <h6 className="text-[#134E47] font-semibold">
                            {item.delivery}
                          </h6>
                        </div>
                        <div className="">
                          <div className="flex justify-end">
                            <p className="text-[#134E47]">
                              <AiFillStar className="inline " />
                              <span className="text-[13px] font-semibold">
                                4.5/5
                              </span>
                              {/* <span className="text-xs">(120)</span> */}
                            </p>
                          </div>
                          <div className="flex justify-end">
                            <p className="text-[#134E47]">
                              <GiPathDistance className="inline mr-1" />
                              <span className="font-bold">{item.distance}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PharmacyList;
